<template>
  <base-index
    ref="baseIndex"
    :columns="isProvider ? providerColumns : makerColumns"
    :resourceName="resourceName"
    :pk="pk"
    :disabledFilterButton="false"
    :breadcrumbs="breadcrumbs"
  >
    <template v-slot:render.image="{ item }">
      <div><img style="max-width: 100px" :src="item.image" /></div>
    </template>
    <template v-slot:render.publish="{ item }">
      <div>{{ item.publish === 1 ? "公開" : "非公開" }}</div>
    </template>
  </base-index>
</template>

<script>

export default {
  components: {
  },
  data() {
    let commonColumns = [
      {
        value: "template_id",
        text: "テンプレートID",
        filter: true
      },
      {
        value: "template_name",
        text: "テンプレート名",
        filter: true,
        sorter: false
      }
    ];

    return {
      resourceName: "templates",
      pk: "template_id",
      providerColumns: [
        {
          value: "maker_id",
          text: "メーカーID",
          filter: false,
          width: 80
        },
        {
          value: "maker_name",
          text: "メーカー名",
          filter: true,
          type: "select",
          optionType: "common/makers"
        },
        ...commonColumns
      ],
      makerColumns: commonColumns
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "レビューテンプレート一覧",
          disabled: true
        }
      ];
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    }
  },
  created(){
    this.$store.dispatch(`common/makers/options/index`);
  }
};
</script>
